import { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Toolbar } from '@devexpress/dx-react-scheduler-material-ui';
import {
  useIsExtraSmallScreen,
  useIsSmallScreen,
} from '../../../../../../../../Hooks/useFullscreenView';
import { ViewDbSettingsContext } from '../ViewDbSettingsContext';

const useStyles = makeStyles()(theme => ({
  toolbarRootComponent: {
    backgroundColor: theme.palette.common.white,
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  moreKalenderFeatures: {
    zIndex: 10,
    position: 'fixed',
    right: 8,
    bottom: 60,
    backgroundColor: theme.palette.background.default,
    opacity: '0.8',
  },
  hideToolbar: {
    display: 'none',
  },
  showOpenButtonTextIconSmallScreen: {
    [theme.breakpoints.down('sm')]: {
      '& > :first-of-type': {
        '& > :first-of-type': {
          '& > :nth-of-type(3)': {
            display: 'block',
            fontSize: 'x-small',
          },
        },
      },
    },
  },
  hideOpenButtonIconSmallScreen: {
    '& > :first-of-type': {
      '& > :first-of-type': {
        '& > :nth-of-type(4)': {
          display: 'none',
        },
      },
    },
  },
}));

export const ToolbarRootComponent = (props: Toolbar.RootProps) => {
  const viewDbSettingsContext = useContext(ViewDbSettingsContext);
  const { classes, cx } = useStyles();

  const seeMoreFeatures = viewDbSettingsContext.seeMoreFeatures;
  const isSmallScreen = useIsSmallScreen();
  const isExtraSmallScreen = useIsExtraSmallScreen();

  return (
    <>
      <Toolbar.Root
        className={cx(
          classes.toolbarRootComponent,
          classes.showOpenButtonTextIconSmallScreen,
          classes.hideOpenButtonIconSmallScreen,
          {
            [classes.hideToolbar]:
              isSmallScreen && isExtraSmallScreen && !seeMoreFeatures,
          }
        )}
        {...props}
      ></Toolbar.Root>
    </>
  );
};
